import { render } from "./DoubleImage.vue?vue&type=template&id=62986532&scoped=true"
import script from "./DoubleImage.vue?vue&type=script&lang=js"
export * from "./DoubleImage.vue?vue&type=script&lang=js"

import "./DoubleImage.vue?vue&type=style&index=0&id=62986532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62986532"]])

export default __exports__